import { z } from 'zod'

/**
 * What clearing a venue's events amounts to: read before the confirmation as a
 * warning, returned after it as a receipt.
 *
 * The client numbers are the three endings a contact can have — an invitation
 * nobody accepted is deleted, an account someone has used is deactivated, and
 * anyone who is still a contact at another venue is kept whichever choice was
 * made. Keeping the same three in both directions is what lets the dialog promise
 * exactly what the server will do, and then say what it did.
 */
export const venuePurgeCountsSchema = z.object({
  events: z.number().int().nonnegative(),
  clientsDeleted: z.number().int().nonnegative(),
  clientsDeactivated: z.number().int().nonnegative(),
  clientsKept: z.number().int().nonnegative(),
})

export type VenuePurgeCounts = z.infer<typeof venuePurgeCountsSchema>

/**
 * What clearing this venue would remove. `counts` describes the fuller of the two
 * choices — the client numbers are what happens when their accounts are asked to
 * go along — so the dialog can show the cost of each option without asking twice.
 */
export const venuePurgePreviewDtoSchema = z.object({
  venueId: z.string().uuid(),
  venueName: z.string(),
  counts: venuePurgeCountsSchema,
})

export type VenuePurgePreviewDto = z.infer<typeof venuePurgePreviewDtoSchema>

/** What clearing the venue actually removed. */
export const venuePurgeResultDtoSchema = z.object({ counts: venuePurgeCountsSchema })

export type VenuePurgeResultDto = z.infer<typeof venuePurgeResultDtoSchema>
